import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, AsyncValidatorFn, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { EnglishArabicDTO } from '../../Shared/Models/EnglishArabicDTO';
import { MultiLingualHtmlEditorOptions } from '../../Shared/Models/MultiLingualHtmlEditorOptions';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { LangChangeEvent } from '@ngx-translate/core';
import { LanguageMode } from '../../Shared/Enums/LanguageMode';


@Component({
  selector: 'BBSF-MultiLingualHtmlEditor',
  templateUrl: './MultiLingualHtmlEditor.component.html',
  styleUrls: ['./MultiLingualHtmlEditor.component.scss']
})
export class MultiLingualHtmlEditorComponent implements OnInit {

  static controlContainerstatic = null;
  constructor(private ErrorHandler: ErrorMassageValidation, public MultiLingualHtmlEditorFormControlHost: FormGroupDirective, @Optional() private controlContainer: ControlContainer, private controlUtility: ControlUtility
  ) {
    MultiLingualHtmlEditorComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: MultiLingualHtmlEditorOptions;
  @Output() OnChange = new EventEmitter();


  ArabicHtmlEditorFormControl: AbstractControl;
  EnglishHtmlEditorFormControl: AbstractControl;
  MultiTextAreaFormControl: AbstractControl;
  MultilingualHtmlEditorgroup: FormGroup;
  ArabicConfig: any
  EnglishConfig: any

  miscList: any
  styleList: any
  fontsizeList: any
  paraList: any
  insertList: any

  CurrentLanguage: string = "";;
  ShowArabicHtmlEditor: boolean
  ShowEnglishHtmlEditor: boolean
  ArabicValidationRules = [];
  ArabicValidationRulesasync = [];
  EnglishValidationRules = [];
  EnglishValidationRulesasync = [];
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];
  ngOnInit() {
    UtilityService.isCreatedBefor = false

    this.CurrentLanguage = UtilityService.CurrentLanguage;

    UtilityService.Translator.onLangChange.subscribe((event: LangChangeEvent) => {
      this.CurrentLanguage = event.lang
      this.showInputUsingLanguageMode();

    });
    this.miscList = this.options.ToolsList_Misc != null ? this.options.ToolsList_Misc : ['codeview', 'undo', 'redo'];
    this.styleList = this.options.ToolsList_Style != null ? this.options.ToolsList_Style : ['bold', 'italic', 'underline', 'clear']
    this.fontsizeList = this.options.ToolsList_FontSize != null ? this.options.ToolsList_FontSize : ['fontname', 'fontsize', 'color']
    this.paraList = this.options.ToolsList_Para != null ? this.options.ToolsList_Para : ['style', 'ul', 'ol', 'paragraph', 'height']
    this.insertList = this.options.ToolsList_Insert != null ? this.options.ToolsList_Insert : ['table', 'picture', 'link', 'video', 'hr']

    this.ArabicConfig = {
      placeholder: this.options.ArabicPlaceholder,
      height: `${this.options.Height}px`,
      toolbar: [
        ['misc', this.miscList],
        ['style', this.styleList],
        ['fontsize', this.fontsizeList],
        ['para', this.paraList],
        ['insert', this.insertList]
      ],
      fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']

    }
    this.EnglishConfig = {
      placeholder: this.options.EngilshPlaceholder,
      height: `${this.options.Height}px`,
      toolbar: [
        ['misc', this.miscList],
        ['style', this.styleList],
        ['fontsize', this.fontsizeList],
        ['para', this.paraList],
        ['insert', this.insertList]
      ],
      fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']

    }
    this.MultilingualHtmlEditorgroup = new FormGroup({});;
    this.MultilingualHtmlEditorgroup.addControl("ArabicHtmlEditorValue", new FormControl(''));
    this.MultilingualHtmlEditorgroup.addControl("EnglishHtmlEditorValue", new FormControl(''));
    this.ArabicHtmlEditorFormControl = this.MultilingualHtmlEditorgroup.controls["ArabicHtmlEditorValue"]; //  new FormControl('',validationRules);
    this.EnglishHtmlEditorFormControl = this.MultilingualHtmlEditorgroup.controls["EnglishHtmlEditorValue"]; //  new FormControl('',validationRules);
    this.group.addControl(this.options.Name, new FormGroup(this.MultilingualHtmlEditorgroup.controls));

    switch (this.options.Type) {
      case InputType.Email:
        this.EnglishValidationRules.push(Validators.compose([
          this.controlUtility.patternValidator(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, { EmailValidationKey: "" }),

        ]));
        this.ArabicValidationRules.push(Validators.compose([
          this.controlUtility.patternValidator(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, { EmailValidationKey: "" }),

        ]));
        break;
      case InputType.Number:
        this.EnglishValidationRules.push(Validators.pattern('^[0-9]+(\.?[0-9]+)?$'));
        this.ArabicValidationRules.push(Validators.pattern('^[0-9]+(\.?[0-9]+)?$'));
        break;
    }

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.EnglishValidationRules.push(Validation.functionBody);
        this.ArabicValidationRules.push(Validation.functionBody);
      }

    }
    if (this.options.MinLength > 0) {
      this.ArabicValidationRules.push(Validators.minLength(this.options.MinLength));
      this.EnglishValidationRules.push(Validators.minLength(this.options.MinLength));
    }

    if (this.options.MaxLength > 0) {
      this.EnglishValidationRules.push(Validators.maxLength(this.options.MaxLength));
      this.ArabicValidationRules.push(Validators.maxLength(this.options.MaxLength));

    }
    if (this.options.ArabicLabelKey != null && this.options.ArabicLabelKey != "")
      this.options.ArabicLabelValue = UtilityService.getResourceValue(this.options.ArabicLabelKey);

    if (this.options.EnglishLabelKey != null && this.options.EnglishLabelKey != "")
      this.options.EnglishLabelValue = UtilityService.getResourceValue(this.options.EnglishLabelKey);

    this.showInputUsingLanguageMode();
    this.ArabicHtmlEditorFormControl.setValidators(this.ArabicValidationRules);
    this.ArabicHtmlEditorFormControl.setAsyncValidators(this.ArabicValidationRulesasync);
    this.EnglishHtmlEditorFormControl.setValidators(this.EnglishValidationRules);
    this.EnglishHtmlEditorFormControl.setAsyncValidators(this.EnglishValidationRulesasync);

    if (this.options.IsDisabled) {
      this.EnglishHtmlEditorFormControl.disable();
      this.ArabicHtmlEditorFormControl.disable();
    }
    this.ArabicHtmlEditorFormControl.setValue(this.options.Value.Arabic)
    this.EnglishHtmlEditorFormControl.setValue(this.options.Value.English)
    this.MultiLingualHtmlEditorFormControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })
  }


  onTextChange() {
    let arabicValue: string = this.MultilingualHtmlEditorgroup.controls["ArabicHtmlEditorValue"].value == null ? "" : this.MultilingualHtmlEditorgroup.controls["ArabicHtmlEditorValue"].value;
    let englishValue: string = this.MultilingualHtmlEditorgroup.controls["EnglishHtmlEditorValue"].value == null ? "" : this.MultilingualHtmlEditorgroup.controls["EnglishHtmlEditorValue"].value;

    let EngliswordCountArray = (this.EnglishHtmlEditorFormControl.value as string).split(" ").length
    if (EngliswordCountArray > 0) {
      if (EngliswordCountArray > this.options.MaxWordCount)
        this.MultilingualHtmlEditorgroup.controls["EnglishHtmlEditorValue"].setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount })
      this.MultilingualHtmlEditorgroup.controls["EnglishHtmlEditorValue"].markAsTouched()
      this.MultilingualHtmlEditorgroup.controls["EnglishHtmlEditorValue"].invalid

    }

    let ArabicwordCountArray = (this.ArabicHtmlEditorFormControl.value as string).split(" ").length
    if (ArabicwordCountArray > 0) {
      if (ArabicwordCountArray > this.options.MaxWordCount)
        this.MultilingualHtmlEditorgroup.controls["ArabicHtmlEditorValue"].setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount })
      this.MultilingualHtmlEditorgroup.controls["ArabicHtmlEditorValue"].markAsTouched()
      this.MultilingualHtmlEditorgroup.controls["ArabicHtmlEditorValue"].invalid

    }

    let mulitLangModel = new EnglishArabicDTO()
    mulitLangModel.Arabic = arabicValue;
    mulitLangModel.English = englishValue
    this.ArabicHtmlEditorFormControl.value(arabicValue);
    this.EnglishHtmlEditorFormControl.value(arabicValue);
    this.OnChange.emit(mulitLangModel)
    this.group.get(this.options.Name).setValue(mulitLangModel)

  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }



  showInputUsingLanguageMode() {

    this.ArabicValidationRules = this.ArabicValidationRules.filter(item => item !== Validators.required);
    this.EnglishValidationRules = this.EnglishValidationRules.filter(item => item !== Validators.required);

    this.ArabicHtmlEditorFormControl.clearValidators();
    this.EnglishHtmlEditorFormControl.clearValidators();

    this.ArabicHtmlEditorFormControl.updateValueAndValidity();
    this.EnglishHtmlEditorFormControl.updateValueAndValidity();

    switch (this.options.LanguageMode) {
      case LanguageMode.Both_Languages_are_visible:
        this.ShowArabicHtmlEditor = true;
        this.ShowEnglishHtmlEditor = true;
        if (this.options.IsRequired == true) {
          this.EnglishValidationRules.push(Validators.required);
          this.ArabicValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Arabic_Language_only_is_visible:
        this.ShowArabicHtmlEditor = true;
        break;
      case LanguageMode.English_Language_only_is_visible:
        this.ShowEnglishHtmlEditor = true;
        break;
      case LanguageMode.Both_Languages_are_visible_but_only_current_language_is_required:
        this.ShowArabicHtmlEditor = true;
        this.ShowEnglishHtmlEditor = true;

        if (this.CurrentLanguage == 'ar') {
          if (this.options.IsRequired == true) {
            this.ArabicValidationRules.push(Validators.required);

          }
        }
        if (this.CurrentLanguage == 'en') {
          if (this.options.IsRequired == true) {
            this.EnglishValidationRules.push(Validators.required);


          }
        }
        break;
      case LanguageMode.Both_Languages_but_only_Arabic_is_required:
        this.ShowArabicHtmlEditor = true;
        this.ShowEnglishHtmlEditor = true;
        if (this.options.IsRequired == true) {
          this.ArabicValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Both_Languages_but_only_English_is_required:
        this.ShowArabicHtmlEditor = true;
        this.ShowEnglishHtmlEditor = true;
        if (this.options.IsRequired == true) {
          this.EnglishValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Current_Language_only_is_visible_and_required:
        if (this.CurrentLanguage == 'ar') {
          this.ShowArabicHtmlEditor = true;
          this.ShowEnglishHtmlEditor = false;

          if (this.options.IsRequired == true) {
            this.ArabicValidationRules.push(Validators.required);

          }
        }
        if (this.CurrentLanguage == 'en') {
          this.ShowArabicHtmlEditor = false;
          this.ShowEnglishHtmlEditor = true;

          if (this.options.IsRequired == true) {
            this.EnglishValidationRules.push(Validators.required);

          }
        }
        break;
      default:
        break;
    }

    this.ArabicHtmlEditorFormControl.setValidators(this.ArabicValidationRules);
    this.EnglishHtmlEditorFormControl.setValidators(this.EnglishValidationRules);
    this.ArabicHtmlEditorFormControl.updateValueAndValidity();
    this.EnglishHtmlEditorFormControl.updateValueAndValidity();

  }


  //External Method

  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.EnglishHtmlEditorFormControl, this.EnglishValidationRules, this.options)
    this.controlUtility.RemoveRequiredValidation(this.ArabicHtmlEditorFormControl, this.ArabicValidationRules, this.options)
  }
  //External Method

  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.EnglishHtmlEditorFormControl, this.EnglishValidationRules, this.options)
    this.controlUtility.AddRequiredValidation(this.ArabicHtmlEditorFormControl, this.ArabicValidationRules, this.options)
  }



  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.EnglishHtmlEditorFormControl, this.EnglishValidationRules, CustomValidation)
    this.controlUtility.RemoveCustomValidation(this.ArabicHtmlEditorFormControl, this.ArabicValidationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.EnglishHtmlEditorFormControl, this.EnglishValidationRules, CustomValidation)
    this.controlUtility.AddCustomValidation(this.ArabicHtmlEditorFormControl, this.ArabicValidationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.EnglishHtmlEditorFormControl)
    this.controlUtility.IsValid(this.ArabicHtmlEditorFormControl)
  }
}

